module.exports = __webpack_public_path__ + "static/img/planta.310aab7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/nuestros-comienzos-en/planta.jpg
// module id = id2H
// module chunks = 0